<template>
  <CContainer class="d-flex content-center min-vh-100">
    <CRow>
      <CCol>
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm validated novalidate>
                <h1>Login</h1>
                <p class="text-muted">B2B Gardenparts logowanie</p>

                <CInput
                  v-model="u"
                  placeholder="nazwa logowania"
                  autocomplete="username email"
                  required
                >
                  <template #prepend-content>
                    <CIcon name="cil-user" />
                  </template>
                </CInput>
                <CInput
                  v-model="h"
                  placeholder="hasło"
                  type="password"
                  autocomplete="curent-password"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked" />
                  </template>
                </CInput>
                <CRow>
                  <CCol>
                    <CAlert
                      show
                      color="danger"
                      v-if="fieldsempty"
                    >Wpisz nazwę użytkownika i hasło, aby się zalogować</CAlert>
                    <CAlert
                      show
                      color="danger"
                      v-if="!fieldsempty && !loginsuccess"
                    >Błąd logowania: {{loginresultmsg}}</CAlert>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol col="6" class="text-left">
                    <CButton @click="mthLoginButtonClick()" color="primary" class="px-4">Zaloguj się</CButton>
                  </CCol>
                  <CCol col="6" class="text-right">
                    <!-- <CButton color="link" class="px-0">Forgot password?</CButton> -->
                    <CButton color="link" class="d-md-none">Register now!</CButton>
                  </CCol>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
            color="primary"
            text-color="white"
            class="text-center py-5 d-sm-down-none"
            body-wrapper
          >
            <h2>Poprzednia wersja Panelu</h2>
            <CButton
              @click="mthGoToOldPanel()"
              color="primary"
              class="active mt-3"
            >Przejdź do starego panelu</CButton>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      u: "",
      h: "",
      fieldsempty: false,
      loginsuccess: true,
      loginresultmsg: "",
    };
  },
  methods: {
    mthSaveUserToLocalstore(userobj) {
      localStorage.setItem("garb2buser", JSON.stringify(userobj));
    },
    mthRedirectAfterLogin(userobj) {
      this.$router.replace("/dashboard");
    },
    mthLogin() {
      //login
      var apiurl =
        process.env.VUE_APP_API_URL +
        "/loginb2b?a=" +
        this.u +
        "&b=" +
        this.h +
        "";
      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          //console.log("response:");
          //console.log(response.data);

          if (response.data.id == "0") {
            that.loginsuccess = false;
            that.loginresultmsg = "Nieprawidłowa nazwa użytkownika lub hasło.";
          } else {
            that.loginsuccess = true;
            that.mthSaveUserToLocalstore(that.u);
            that.mthRedirectAfterLogin(response.data);
          }

          // if (!response.data.id && response == "error") {
          //   that.msg =
          //     "Nieprawidłowa nazwa użytkownika lub hasło (" +
          //     response.data +
          //     ").";
          //   console.log(that.u);
          //   console.log(that.msg);
          //   console.log(that.kkk++);
          // } else if (!response.data.id) {
          //   that.msg = "Błąd API (" + response.data + ")";
          // } else {
          //   that.mthSaveToStore(response.data);
          //   //location = "/warehouse";
          //   that.$router.replace("/warehouse");

          //   that.msg = "Proszę czekać na przekierowanie do aplikacji...";
          // }
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
    mthGoToOldPanel() {
      location = "https://gardenparts.pl/my.admin";
    },
    mthLoginButtonClick() {
      console.log("login");
      this.mthManualValidation();
    },
    mthManualValidation() {
      if (this.u == "" || this.h == "") {
        this.fieldsempty = true;
      } else {
        this.fieldsempty = false;
        this.mthLogin();
      }
    },
  },
};
</script>
